export default {
	async SEND({ state, commit }) {
		axios.defaults.headers.get[state.header.name] = state.header.value;
		axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
		commit('createUpdateDeal/main/setLoad', true, { root: true });
		await axios
			.get('/admin/users/', {
				params: {
					q: state.string
				}
			})
			.then(response => {
				commit('setUsers', typeof response.data.users === 'string' ? JSON.parse(response.data.users) : response.data.users);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('createUpdateDeal/main/setLoad', false, { root: true });
	}
};
